import axios from "axios";
import { downloadFile } from "../utils/filesUtils";
import snackbarUtils from "../utils/snackbarUtils";

export const AUDIT_GET = "AUDIT_GET";
export const AUDIT_GET_ACTION_TYPES = "AUDIT_GET_ACTION_TYPES";
export const AUDIT_GET_DETALLE = "AUDIT_GET_DETALLE";
export const AUDIT_FRONTEND_ACTION = "AUDIT_FRONTEND_ACTION";
export const AUDIT_CLEAR = "AUDIT_CLEAR";

export const CODIGO_AUDITORIA = {
  DESCARGA_DETALLE_JSON: "DESCARGA_DETALLE_JSON",
  DESCARGA_HISTORIA_CLINICA: "DESCARGA_HISTORIA_CLINICA",
  IMPRIMIR_FPA: "IMPRIMIR_FPA",
  IMPRIMIR_FORMULARIO_PREIMPRESO: "IMPRIMIR_FORMULARIO_PREIMPRESO",
  EXPORTACION_SINIESTROS: "EXPORTACION_SINIESTROS",
  EXPORTACION_AUTORIZACIONES_PENDIENTES: "EXPORTACION_AUTORIZACIONES_PENDIENTES",
  EXPORTACION_AUTORIZACIONES_RESPONDIDAS: "EXPORTACION_AUTORIZACIONES_RESPONDIDAS",
  EXPORTACION_TURNOS: "EXPORTACION_TURNOS",
  EXPORTACION_CONECTIVIDAD: "EXPORTACION_CONECTIVIDAD",
  DESCARGA_REPORTE_SESION_TURNOS: "DESCARGA_REPORTE_SESION_TURNOS",
};

const idArtValido = (idArt) => {
  const art = Number(idArt);
  return Number.isInteger(art) && art > 0 ? art : null;
};

export const getAuditoriaPrestadores = (params) => (dispatch) =>
  dispatch({
    type: AUDIT_GET,
    payload: axios
      .get("audit", { params })
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const getAuditActionTypes = () => (dispatch) =>
  dispatch({
    type: AUDIT_GET_ACTION_TYPES,
    payload: axios
      .get("audit/actionTypes")
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const getAuditoriaDetalle = (id, origen) => (dispatch) =>
  dispatch({
    type: AUDIT_GET_DETALLE,
    payload: axios
      .get(`audit/${id}`, { params: { origen } })
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });

export const clearAuditoriaPrestadores = () => ({
  type: AUDIT_CLEAR,
});

export const registrarAccionFrontend = ({ idArt, code, siniestro, numeroDocumento, requestInput }) => (dispatch) => {
  const art = idArtValido(idArt);
  if (!art) {
    return Promise.resolve();
  }

  return dispatch({
    type: AUDIT_FRONTEND_ACTION,
    payload: axios
      .post(`audit/log?idArt=${art}`, {
        code,
        siniestro: siniestro || null,
        numeroDocumento: numeroDocumento || null,
        requestInput: requestInput || null,
      })
      .then((response) => ({ data: response.data }))
      .catch(() => ({ data: null })),
  });
};

export const auditarExportacion = (filas, campoArt, code) => (dispatch) => {
  const ids = [];
  (filas || []).forEach((fila) => {
    const art = idArtValido(fila?.[campoArt]);
    if (art && !ids.includes(art)) {
      ids.push(art);
    }
  });

  if (ids.length === 0) {
    return Promise.resolve();
  }

  return ids.reduce(
    (cadena, idArt) => cadena.then(() => dispatch(registrarAccionFrontend({ idArt, code }))),
    Promise.resolve(),
  );
};

export const descargarDetalleAuditoria = (detalle, contenido, extension, lado) => (dispatch) => {
  const art = idArtValido(detalle?.idArt);
  const auditPromise = art
    ? dispatch(registrarAccionFrontend({
      idArt: art,
      code: CODIGO_AUDITORIA.DESCARGA_DETALLE_JSON,
      siniestro: detalle.siniestro,
      numeroDocumento: detalle.numeroDocumento,
      requestInput: `IdMovimientoLog: ${detalle.idMovimientoLog}; Accion: ${detalle.accion || ""}; Lado: ${lado || ""}; Formato: ${extension || ""}`,
    }))
    : Promise.resolve();

  return auditPromise.then(() => {
    downloadFile(contenido, `auditoria-${detalle.idMovimientoLog}.${extension || "txt"}`);
    snackbarUtils.success("Detalle descargado correctamente.");
    return { data: true };
  });
};
